var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"staticReadOnly"},[(true)?_c('div',[_c('b-btn',{on:{"click":_vm.onSubmit}},[_vm._v(" Continue activity ")])],1):_c('div',[_c('b-alert',{attrs:{"show":""}},[_vm._v(" Parameter could not be retrieved at this time. Please contact \""+_vm._s(_vm.contact)+"\" for further assistance. ")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }